import { useEffect, useState } from "react";
import axios from "axios";
import { CONTENT_ROUTES } from "../routes/content-routes";
import { useUtilities } from "../hooks/utilities";
import { NavLink } from "react-router-dom";
import { WEB_ROUTES } from "../routes/web-routes";
import FormNewsletter from "../components/form-newsletter";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { FaLinkedin, FaXTwitter, FaFacebook } from "react-icons/fa6";

export default function Footer() {
  const [page, setPage] = useState({});
  const [pageMedia, setPageMedia] = useState([]);
  let { getMetaSnippet } = useUtilities();

  useEffect(() => {
    axios
      .get(CONTENT_ROUTES.POST_PAGE("/pages", "footer"))
      .then((res) => {
        const pageResponse = res.data?.length ? res.data[0] : {};
        setPage(pageResponse);
        //Get page media
        axios
          .get(CONTENT_ROUTES.MEDIA_BY_PAGE(pageResponse?.id))
          .then((res) => {
            setPageMedia(res.data);
          });
      })
      .catch((err) => {})
      .finally(() => {});
  }, []);

  return (
    <footer className="bg-gradient-to-bl from-[#0e233e] to-[#0071b9]">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="mx-auto container pb-16 pt-16 md:px-0 px-8">
        <div className="md:grid md:grid-cols-6 md:gap-8">
          <div className="text-white col-span-2">
            <NavLink to={WEB_ROUTES.HOME} className="inline-block">
              <img
                className="mb-5 h-20"
                src="/images/nant-power-logo-white.svg"
                alt="Nant Power Project Logo"
              />
            </NavLink>
            <div className="max-w-md mb-4 mr-10">
              <p
                dangerouslySetInnerHTML={{
                  __html: page?.content?.rendered,
                }}
              />
              <div className="flex space-x-4 mt-6">
                <a
                  href="https://www.facebook.com/profile.php?id=61578106486775"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook className="text-white hover:text-blue-400 text-2xl" />
                </a>
                <a
                  href="https://x.com/Nant_Power"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaXTwitter className="text-white hover:text-blue-400 text-2xl" />
                </a>
                <a
                  href="https://www.linkedin.com/company/nant-power/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin className="text-white hover:text-blue-400 text-2xl" />
                </a>
              </div>
            </div>
          </div>
          <div className="mt-10 md:mt-0 col-span-1">
            <h3 className="font-medium text-[#58b947] text-lg">Quick Links</h3>
            <ul className="mt-6 space-y-4">
              <li>
                <NavLink to={WEB_ROUTES.HOME} className="text-white">
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to={WEB_ROUTES.ABOUT} className="text-white">
                  About Nant Power
                </NavLink>
              </li>
              <li>
                <NavLink to={WEB_ROUTES.PROJECT} className="text-white">
                  The Project
                </NavLink>
              </li>
              <li>
                <NavLink to={WEB_ROUTES.GALLERY} className="text-white">
                  Gallery
                </NavLink>
              </li>
              <li>
                <NavLink to={WEB_ROUTES.IMPACT} className="text-white">
                  Impact
                </NavLink>
              </li>
              <li>
                <NavLink to={WEB_ROUTES.NEWS} className="text-white">
                  News & Media
                </NavLink>
              </li>
              <li>
                <NavLink to={WEB_ROUTES.CONTACT} className="text-white">
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>

          <div className="mt-10 md:mt-0 col-span-1">
            <h3 className="font-medium text-[#58b947] text-lg">Website Use</h3>
            <ul className="mt-6 space-y-4 text-white">
              {/* <li>
                <NavLink
                  to={WEB_ROUTES.CORPORATE_POLICIES}
                  className="text-white"
                >
                  Corporate Policies
                </NavLink>
              </li>
              <h3 className="font-medium text-[#58b947] text-lg">
                Website Use
              </h3> */}
              <li>
                <NavLink to={WEB_ROUTES.PRIVACY_POLICY} className="text-white">
                  Privacy Policy
                </NavLink>
              </li>
              <li>
                <NavLink to={WEB_ROUTES.TERMS} className="text-white">
                  Terms of Use
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={WEB_ROUTES.COPYRIGHT_STATEMENT}
                  className="text-white"
                >
                  Copyright Statement
                </NavLink>
              </li>
              <li>
                <NavLink to={WEB_ROUTES.COOKIE_POLICY} className="text-white">
                  Cookie Policy
                </NavLink>
              </li>
            </ul>
          </div>

          <div className="mt-10 md:mt-0 col-span-2">
            <h3 className="mb-6 font-medium text-[#58b947] text-lg">
              Subscribe to our mailing list
            </h3>
            <div className="relative">
              <GoogleReCaptchaProvider reCaptchaKey="6LfcxHorAAAAAAdbYDy1YHUNOxmQeE9lrjMZa0tX">
                <FormNewsletter bgType={`light`} />
              </GoogleReCaptchaProvider>
            </div>
          </div>
        </div>
      </div>

      <div className="py-10 mx-auto container md:space-x-4 space-x-0 text-white">
        <div className="mb-0 md:mt-0 mt-4 mx-8 md:mx-0">
          &copy; Copyright {new Date().getFullYear()}{" "}
          <span
            dangerouslySetInnerHTML={{
              __html: page?.acf?.copyright_statement,
            }}
          />
        </div>
      </div>
    </footer>
  );
}
